import { render, staticRenderFns } from "./Oluma.vue?vue&type=template&id=2cd65310&scoped=true&"
import script from "./Oluma.vue?vue&type=script&lang=js&"
export * from "./Oluma.vue?vue&type=script&lang=js&"
import style0 from "./Oluma.vue?vue&type=style&index=0&id=2cd65310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd65310",
  null
  
)

export default component.exports